export class CombinationAlarmParameters {

    constructor(
        public expression: string = null,
        public message: string = null
    ) {
    }

}
